module.exports = require('./helpers/bundle-url').getBundleURL('9R8Ou') + "logo.c51670a8.svg";